// extracted by mini-css-extract-plugin
module.exports = {"StickyColumn":"sticky-column_StickyColumn___Wd9F"};